import { createSlice } from '@reduxjs/toolkit'

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    appName: 'Qroq',
    files: [],
    description: 'Qroq is a smart app to create, customize, and manage dynamic QR codes easily.',
    website: 'https://qroq.in',
    androidApp: 'https://play.google.com/store/apps/details?id=com.qroq.android&hl=en&gl=US',
    iOSApp: 'https://apps.apple.com/us/app/qroq',
    fontFamily: 'Arial, sans-serif',
    cardColor: '#ffffff',
    appNameColor: '#000000',
    descriptionColor: '#000000',
    websiteTextColor: '#000000',
    showWebsiteAltText: false,
    websiteAltText: '',
    altButtonBackgroundColor: '#000000',
    altButtonTextColor: '#ffffff'
  },
  reducers: {
    setAppField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    setLogoImage(state, action) {
      state.files[0] = action.payload
    },
    initializeApp(state, action) {
      state.appName = 'Qroq'
      state.files = []
      state.description = 'Qroq is a smart app to create, customize, and manage dynamic QR codes easily.'
      state.website = 'https://qroq.in'
      state.androidApp= 'https://play.google.com/store/apps/details?id=com.qroq.android&hl=en&gl=US'
      state.iOSApp= 'https://apps.apple.com/us/app/qroq'
      state.fontFamily = 'Arial, sans-serif'
      state.cardColor = '#ffffff'
      state.appNameColor = '#000000'
      state.descriptionColor = '#000000'
      state.websiteTextColor = '#000000'
      state.showWebsiteAltText = false
      state.websiteAltText = ''
      state.altButtonBackgroundColor = '#000000'
      state.altButtonTextColor = '#ffffff'
    }
  }
})

export const {
  setAppField,
  setLogoImage,
  initializeApp
} = appSlice.actions
export default appSlice.reducer